import classNames from 'classnames/bind';
import { shallow } from 'zustand/shallow';
import { CommonButton } from '../common/button';
import styles from './permission.module.scss';
import React from 'react';
import useInterviewPracticeStore from '@stores/InterviewStore/InterviewPracticeStore';

const cx = classNames.bind(styles);

export const Permission = () => {
  const { toNextStep } = useInterviewPracticeStore((state) => state.practiceStepInfo, shallow);

  const handleConfirmVoiceClick = () => {
    toNextStep();
  };

  return (
    <div className={cx('permission')}>
      <div className={cx('message')}>
        기출 면접 연습 진행을 위해
        <br />
        차단된 오디오 재생을 허용할게요.
      </div>
      <div className={cx('btnWrap')}>
        <CommonButton className={cx('btnDownload')} type={'black'} onClick={handleConfirmVoiceClick}>
          확인
        </CommonButton>
      </div>
    </div>
  );
};
